/* eslint-disable @typescript-eslint/no-unused-vars */
import { useTPAxios } from "@/api/useTPAxios.ts";
import { ApiError } from "@/utils/apiError.model";
import i18n from "@/utils/i18n.utils";
import { RequestProps } from "@/utils/response.utils";
import { useMutation } from "@tanstack/react-query";
import { AxiosInstance, AxiosResponse } from "axios";
import { User } from "../auth/user.model";
import { AuthStore } from "../auth/auth.store";


export type UpdateProfileProps = {
  firstName: string;
  lastName: string;
  phoneNumber?: string;
  phoneCode?: string;
  nationalityCode?: string;
  countryCode?: string;
  gender?: string;
  birthdate?: string;
}

const updateProfile = async (
  body: UpdateProfileProps,
  TPAxios: AxiosInstance,
): Promise<AxiosResponse<User>> => {
  const data = Object.fromEntries(
    Object.entries(body).filter(
      ([_, v]) => v !== null && v !== undefined && v !== ''
    )
  );
  const response = await TPAxios.put<AxiosResponse<User>>(
    '/customers/me',
    data,
  );

  return response.data;
}

const deleteAccount = async (
  erase: boolean,
  TPAxios: AxiosInstance,
): Promise<void> => {
  await TPAxios.delete(
    '/customers/me',
    {
      data: {
        erase
      }
    }
  );
}

export const useUpdateProfile = (
  props: RequestProps
) => {
  const { onSuccess, onError } = props;
  const TPAxios = useTPAxios();
  const { updateUser } = AuthStore();

  return useMutation({
    mutationFn: (body: UpdateProfileProps) => updateProfile(body, TPAxios),
    onSuccess: async (data) => {
      updateUser(data.data);
      onSuccess();
    },
    onError: (error) => {
      const err = error as ApiError;
      const errorCode = err.response?.data.errorCode;
      onError(i18n.t(`errors.${errorCode}`));
    }
  })
}

export const useDeleteAccount = (
  props: RequestProps
) => {
  const { onSuccess, onError } = props;
  const TPAxios = useTPAxios();

  return useMutation({
    mutationFn: (erase: boolean) => deleteAccount(erase, TPAxios),
    onSuccess: () => {
      onSuccess();
    },
    onError: (error) => {
      const err = error as ApiError;
      const errorCode = err.response?.data.errorCode;
      onError(i18n.t(`errors.${errorCode}`));
    }
  })
}